import {
  HttpHeaders,
  HttpClient,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { environment } from 'src/environments/environment';
import { Ward } from '../Models/ward.model';

@Injectable({
  providedIn: 'root',
})
export class WardService {
  url = environment.Url + 'Wards';
  roomUrl = environment.Url + 'Wards/wardRooms';
  nurseHandOffNote = environment.Url + 'Wards/nurseHandOffNote';
  wardPatients = environment.Url + 'Wards/wardPatients';
  dutyRosterByShift = environment.Url + 'Wards/dutyRosterByShift';

  header = new HttpHeaders({
    Authorization: 'token' + localStorage.getItem('token'),
  });

  constructor(private http: HttpClient) {}

  registerWard(body) {
    return this.http
      .post<Ward>(this.url, body)
      .pipe(catchError(this.handleError));
  }

  getWards() {
    return this.http.get<Ward[]>(this.url).pipe(catchError(this.handleError));
  }
  getWardById(id) {
    return this.http
      .get<Ward>(this.url + '/' + id)
      .pipe(catchError(this.handleError));
  }
  getWardRooms(id) {
    return this.http
      .get<Ward>(this.roomUrl + '/' + id)
      .pipe(catchError(this.handleError));
  }
  getNurseHandOffNote(id) {
    return this.http
      .get<Ward>(this.nurseHandOffNote + '/' + id)
      .pipe(catchError(this.handleError));
  }
  getDutyRosterByShift(id) {
    return this.http
      .get<Ward>(this.dutyRosterByShift + '/' + id)
      .pipe(catchError(this.handleError));
  }
  getWardPatients(id) {
    return this.http
      .get<Ward>(this.wardPatients + '/' + id)
      .pipe(catchError(this.handleError));
  }

  updateWard(id, body) {
    return this.http
      .put<Ward>(this.url + '/' + id, body)
      .pipe(catchError(this.handleError));
  }

  deleteWard(id) {
    return this.http
      .delete<Ward>(this.url + '/' + id)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      if (error.status == 400) {
        console.log(error.error);
        return throwError(error.error);
      } else if (error.status == 401) {
        return throwError('invalid username or password');
      } else if (error.status == 0) {
        return throwError('network failure please try again later ');
      }
      return throwError(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  }
}
